/**
 * 大屏出口
 */
import axios from '../http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const screen = {
    // 修改
    updinfomation(params) {
        return axios.post(api + 'screen/updinfomation', qs.stringify(params))
    },
    // 单个查看
    infomation(params) {
        return axios.get(api + 'screen/infomation', { params: params })
    },
}

// 导出接口
export default screen
